import { useMutation, useQueryClient } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/lib/queryKeys'

import { UserPkg } from '../types/UserPkg'
import { uploadUserPkgReceipt } from '../userPkgService'

export const useUploadUserPkgReceipt = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: uploadUserPkgReceipt,
    onSuccess: async (res, { packageId }) => {
      await queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.PACKAGE_PAYMENTS_SUMMARY, packageId] })
      console.log({ res })
      queryClient.getQueryData([QUERY_KEYS.USER_PACKAGES])
      queryClient.setQueryData<UserPkg[]>([QUERY_KEYS.USER_PACKAGES], old =>
        old?.map(item =>
          item.id === packageId
            ? {
                ...item,
                buyingReciptKey: res.buyingReciptKey,
                price: res.price,
                falseReceiptDate: res.falseReceiptDate,
                valueInUSD: res.valueInUSD,
              }
            : item
        )
      )
    },
  })
}
